import { render, staticRenderFns } from "./addGift.vue?vue&type=template&id=d22a04de&scoped=true&"
import script from "./addGift.vue?vue&type=script&lang=js&"
export * from "./addGift.vue?vue&type=script&lang=js&"
import style0 from "./addGift.vue?vue&type=style&index=0&id=d22a04de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22a04de",
  null
  
)

export default component.exports